export class ClientUser {
    constructor(
        public id: string,
        public username: string,
        public roles: string[]
    ) {}
}
